import React from "react";
import "./index.css";

// ScrollAnimation component (reused from previous components)
class ScrollAnimation extends React.Component {
  state = {
    isVisible: false,
  };

  domRef = React.createRef();

  componentDidMount() {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.setState({ isVisible: true });
        observer.unobserve(this.domRef.current);
      }
    });

    observer.observe(this.domRef.current);
  }

  render() {
    const { children, stagger } = this.props;
    const staggerClass = stagger ? `stagger-${stagger}` : "";

    return (
      <div
        className={`cta-scroll-animation ${
          this.state.isVisible ? "is-visible" : ""
        } ${staggerClass}`}
        ref={this.domRef}
      >
        {children}
      </div>
    );
  }
}

class CallToAction extends React.Component {
  handleScroll = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href") || "";
    const targetId = href.replace("#", "");
    const element = document.getElementById(targetId);

    if (element) {
      const yOffset = -80; // Adjust based on navbar height
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  render() {
    return (
      <section className="cta-section">
        <div className="cta-background">
          <div className="cta-overlay"></div>
          <img
            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
            alt="Team collaboration"
            className="cta-image"
          />
        </div>

        <div className="cta-container">
          <ScrollAnimation>
            <div className="cta-content">
              <h2 className="cta-title">Ready to Transform Your Business?</h2>
              <p className="cta-description">
                Partner with W.L.W. Enterprise and gain access to our expertise
                in business development, promotion, and marketing. Let's build
                your success together.
              </p>
              <div className="cta-buttons">
                <a
                  href="#appointment"
                  onClick={this.handleScroll}
                  className="cta-button cta-button-primary"
                >
                  Schedule a Consultation
                </a>
                <a
                  href="#contact"
                  onClick={this.handleScroll}
                  className="cta-button cta-button-secondary"
                >
                  Contact Us Today
                </a>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </section>
    );
  }
}

export default CallToAction;
